import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import useVehicleFetcher from '../hooks/useVehicleFetcher'
import Vehicle from '../interfaces/Vehicle'
import { fechaIsoToYYYY_MM_DD, formatDate } from '../utils/utils'
import insuranceTranslate from '../utils/insuranceTranslate'
import permitTranslate from '../utils/permitTranslate'
import maintenanceTranslate from '../utils/maintenanceTranslate'
import characteristicTranslate from '../utils/characteristicTranslate'
import { useAuth } from '../hooks/useAuth'
import UserData from '../interfaces/UserData'
import bodyTranslate from '../utils/bodyTranslate'

import VehicleDetail from './VehicleDetail'

const VehicleDetailPage: React.FC = () => {
  const { errorVehicle, fetchVehicle } = useVehicleFetcher()
  const [vehicle, setVehicle] = useState<Vehicle | null>(null)
  const [localError, setLocalError] = useState<string | null>(null)
  const { userData } = useAuth()
  const [refreshKey, setRefreshKey] = useState(0) // A key to trigger re-fetching
  // Mantenemos el estado para evitar que no se cierren las ventanas de
  // ingreso y egreso y para que los cambios se reflejen.
  const [clickedSubMenuIndex, setClickedSubMenuIndex] = useState<number>(-1)

  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    if (!id) {
      setLocalError('ID is not defined.')

      return // Exit early if `id` is undefined
    }

    const fetchDataAsync = async () => {
      const veh = await fetchVehicle(id)

      if (!veh || !userData) return
      const vehicleaux = convertToDisplay(veh, userData)
      setVehicle(vehicleaux)

      if (veh.state !== 'STATE.VEHICLE.PURCHASED') {
        // Buscamos el cliente de la ultima consignacion
      }
    }

    fetchDataAsync()
  }, [id, refreshKey])

  const handleRefresh = () => setRefreshKey((prev) => prev + 1) // Increment the refreshKey to trigger re-fetch

  if (errorVehicle) return <div>Error: {errorVehicle.message}</div>

  if (localError) return <div>Error: {localError}</div>

  return vehicle ? (
    <VehicleDetail
      vehicle={vehicle}
      onRefresh={handleRefresh}
      clickedSubMenuIndex={clickedSubMenuIndex}
      setClickedSubMenuIndex={setClickedSubMenuIndex}
    />
  ) : null
}

/* Convertimos las propiedades de Vehicle para dejarlas listas
 * para su depliegue
 */
const convertToDisplay = (vehicle: Vehicle, userData: UserData) => {
  vehicle.body_format = bodyTranslate(vehicle.type, vehicle.body, userData.bodies ?? [])

  if (vehicle.documents) {
    const docs = vehicle.documents
    docs.insurance = insuranceTranslate[docs.insurance] || docs.insurance
    docs.permit = permitTranslate[docs.permit] || docs.permit

    if (docs.checkup) {
      docs.checkup = formatDate(docs.checkup)
    }
    vehicle.documents = docs
  }

  if (vehicle.maintenance) {
    const maintenance = vehicle.maintenance
    maintenance.status = maintenanceTranslate[maintenance.status] || maintenance.status
    vehicle.maintenance = maintenance
  }

  if (vehicle.characteristics) {
    const updatedChars = vehicle.characteristics.map((dto) => {
      return characteristicTranslate[dto] || dto
    })

    vehicle.characteristics = updatedChars
  } else {
    vehicle.characteristics = []
  }

  vehicle.branch_name = vehicle.branch

  if (vehicle.archivedAt) {
    vehicle.archivedAt = fechaIsoToYYYY_MM_DD(vehicle.archivedAt)
  }

  for (const branch of userData?.branches ?? []) {
    if (branch._id === vehicle.branch) {
      vehicle.branch_name = branch.name
      break
    }
  }

  return vehicle
}

export default VehicleDetailPage
